module.exports = __webpack_public_path__ + "static/media/crmicon.c7e596fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crmicon.svg
// module id = 2184
// module chunks = 0